// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// PRODUCT/CAPTIONS (360 ANIMATION)


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const elements = document.querySelectorAll(".msdw-animate");

function check(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("msdw-animated");
      observer.unobserve(entry.target);
    }
  });
}

const observer = new IntersectionObserver(check);

elements.forEach((elem) => observer.observe(elem));



const elementsFade = document.querySelectorAll(".msdw-animate-fade");

const optionsFade = {
  threshold: 1,
}

function checkFade(entries) {
  entries.map((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("msdw-animated-fade");
      observer2.unobserve(entry.target);
    }
  });
}

const observer2 = new IntersectionObserver(checkFade, optionsFade);

elementsFade.forEach((elem2) => observer2.observe(elem2));


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

const productSlider = new Swiper ('.msdw-product-slider', {
  noSwipingClass: "no-swipe",
  slidesPerView: 1,
  spaceBetween: 0,
  effect: "fade",
  fadeEffect: { crossFade: true },
  speed: 5,
  loop: false,
  pagination: {
    el: ".msdw-product-slider-pagination",
    clickable: true,
  },
  initialSlide: 0,
});


//
// =PRODUCT/CAPTIONS (360 ANIMATION)
// --------------------------------------------------

// *** DO NOT USE window.onload ***
gsap.registerPlugin(ScrollTrigger);

const frame_count  = 22; // total - 1
      // offset_value = viewerWidth;
      offset_value = 100 / frame_count;

const productAnim = gsap.timeline({
  paused: true,
  defaults: {
    ease: Linear.easeNone,
    // overwrite: true,
  }
})
  .to(".msdw-viewer", { duration: 3,
    // backgroundPosition: (-offset_value * frame_count) + "px 50%",
    backgroundPosition: (offset_value * frame_count) + "% 50%",
    ease: "steps(" + frame_count + ")",
  })
  .fromTo('.msdw-feature-1', { duration: 0.75, autoAlpha: 1 }, { autoAlpha: 1 }, "<")
  .to('.msdw-feature-1', { duration: 0.25, autoAlpha: 0 }, "<0.75")
  .to('.msdw-feature-2', { duration: 1, autoAlpha: 1 }, "<-0.25")
  .to('.msdw-feature-2', { duration: 0.25, autoAlpha: 0 }, "<1.5")
  .to('.msdw-feature-3', { duration: 1, autoAlpha: 1 }, "<-0.25");
  // .to({}, {duration: 0.2}); // just a little pause before unpinning

ScrollTrigger.create({
  // invalidateOnRefresh: true,
  // invalidateOnResizes: true,
  trigger: ".msdw-sticky",
  start: "center center",
  // end: "+=" + frame_count * offset_value,
  end: "+=1250",
  pin: true,
  // scrub: true,
  scrub: 1,
  animation: productAnim,
});

gsap.to(".msdw-parallax-1", {
  y: 150,
  scrollTrigger: {
    scrub: true
  },
});

gsap.to(".msdw-parallax-2", {
  y: -900,
  scrollTrigger: {
    scrub: true
  },
});
